import React, { Component } from "react"
import { InputCustom } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"
export default class RelatorioVigenciasForm extends Component {
  constructor() {
    super()
    this.onChangeDataInicio = this.onChangeDataInicio.bind(this)
    this.onChangeDataFinal = this.onChangeDataFinal.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      dataDeInicio: "",
      dataFinal: ""
    }
  }
  onChangeDataInicio(value) {
    var newValue = value
    this.setState({
      dataDeInicio: newValue
    })
  }
  onChangeDataFinal(value) {
    var newValue = value
    this.setState({
      dataFinal: newValue
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Vigência",
      start_date: Util.dateOnly(this.state.dataDeInicio),
      end_date: Util.dateOnly(this.state.dataFinal)
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Relatório de final de vigência.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        console.log("Error")
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    return (
      <div>
        <div className="row card">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data inicial"
            onChange={this.onChangeDataInicio}
            value={this.state.dataDeInicio}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data final"
            onChange={this.onChangeDataFinal}
            value={this.state.dataFinal}
          />
          <div className="row">
            <button
              onClick={this.sendForm}
              type="submit"
              className="btn btn-primary"
              id="btn-gerar"
              data-background-color="as-blue"
            >
              Gerar
            </button>
          </div>
        </div>
        <span className="label label-primary">
          PS: Se os campos forem deixados em branco, todos os contratos serão
          contemplados
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioVigenciasForm.js